<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control is-expanded">
              <multiselect v-model="selectedApplicationName"
                placeholder="Select An Application Name"
                track-by="applicationName"
                label="applicationName"
                :options="applicationNames"
                :searchable="true"
                :show-labels="false"
                :allow-empty="true"
                @select="selectApplicationName"
                @remove="removeApplicationName"
                @search-change="getApplicationNameDropdownFilter">
                <span class="has-text-danger"
                  slot="noResult">Application Name not found.</span>
              </multiselect>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth"
                :class="{ 'is-loading': isCompanyLoading }">
                <select v-model="innerValue.companyId"
                  :disabled="isCompanyLoading">
                  <option value="">-- Company --</option>
                  <option v-for="company in companies"
                    :key="company.id"
                    :value="company.id">
                    {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <v-date-picker v-model="selectedFromDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              :attributes="attrs"
              :locale="$userInfo.locale"
              :model-config="{ timeAdjust: '00:00:00' }"
              :timezone="$filters.getIanaTimezone()">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Date From..."
                      :value="inputValue"
                      v-on="inputEvents">
                    <span class="icon mso mso-18px is-small is-left">
                      event
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
          <div class="field">
            <v-date-picker v-model="selectedToDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              :attributes="attrs"
              :locale="$userInfo.locale"
              :model-config="{ timeAdjust: '23:59:59' }"
              :timezone="$filters.getIanaTimezone()">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Date To..."
                      :value="inputValue"
                      v-on="inputEvents">
                    <span class="icon mso mso-18px is-small is-left">
                      event
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="mso mso-18px">
              search
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="mso mso-18px">
              refresh
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import { mask } from 'vue-the-mask'
import _cloneDeep from 'lodash/cloneDeep'
import Multiselect from 'vue-multiselect'
import _debounce from 'lodash.debounce'
import PollingLogService from './PollingLogService'

export default {
  name: 'PollingLogListSideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu,
    Multiselect
  },
  directives: {
    mask
  },
  mixins: [],
  props: {
    filter: null,
    value: null
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      selectedFromDate: null,
      selectedToDate: null,
      selectedApplicationName: null,
      applicationNames: [],
      companies: [],
      isApplicationNameLoading: false,
      isCompanyLoading: false,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ]
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    }
  },
  watch: {
    selectedFromDate: function (newVal, oldVal) {
      if (newVal) {
        this.innerValue.dateFrom = this.selectedFromDate.toISOString()
      } else {
        this.innerValue.dateFrom = ''
      }
    },
    selectedToDate: function (newVal, oldVal) {
      if (newVal) {
        this.innerValue.dateTo = this.selectedToDate.toISOString()
      } else {
        this.innerValue.dateTo = ''
      }
    },
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    value: {
      handler: function (newVal, oldVal) {
        this.innerValue = this.value
      },
      deep: true
    }
  },
  async created() {
    if (this.innerValue.dateFrom) {
      this.selectedFromDate = new Date(this.innerValue.dateFrom)
    }
    if (this.innerValue.dateTo) {
      this.selectedToDate = new Date(this.innerValue.dateTo)
    }
    this.getApplicationNameDropdown()
    this.getCompanyDropdown()
  },
  mounted() {
    // Initialize with current company if available
    // if (this.currentCompany && !this.innerValue.companyId) {
    //   this.innerValue.companyId = this.currentCompany.id
    // }
  },
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.selectedFromDate = null
      this.selectedToDate = null
      this.selectedApplicationName = null
      // Reset to hardcoded application names
      this.applicationNames = [
        { applicationName: 'All Application Names', applicationName: '' },
        { applicationName: 'ORM', applicationName: 'ORM' },
        { applicationName: 'PNET', applicationName: 'PNET' }
      ]
      this.$emit('reset')
    },
    async selectApplicationName(selected) {
      this.innerValue.applicationName = selected.applicationName
    },
    removeApplicationName() {
      this.innerValue.applicationName = null
      this.getApplicationNameDropdown()
    },
    async getApplicationNameDropdown() {
      this.isApplicationNameLoading = true
      try {
        // Hardcoded application names: ORM and PNET
        this.applicationNames = [
          { applicationName: '', applicationName: '' }, // All option
          { applicationName: 'ORM', applicationName: 'ORM' },
          { applicationName: 'PNET', applicationName: 'PNET' }
        ]
        this.applicationNames[0] = { applicationName: 'All Application Names', applicationName: '' }
        this.selectedApplicationName = this.applicationNames.find((c) => c.applicationName === this.innerValue.applicationName)
      } catch (error) {
        this.applicationNames = [
          { applicationName: 'All Application Names', applicationName: '' },
          { applicationName: 'ORM', applicationName: 'ORM' },
          { applicationName: 'PNET', applicationName: 'PNET' }
        ]
      }
      this.isApplicationNameLoading = false
      return this.applicationNames
    },
    getApplicationNameDropdownFilter: _debounce(async function (query) {
      this.getApplicationNameDropdown()
    }, 500),
    async getCompanyDropdown() {
      this.isCompanyLoading = true
      try {
        const companyData = await PollingLogService.getCompanyDropdownProto('')
        this.companies = companyData.map((company) => ({
          id: company.key,
          name: company.value
        }))
      } catch (error) {
        console.error('Error loading companies:', error)
      }
      this.isCompanyLoading = false
      return this.companies
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/mixins/inputs/placeholder' as *;
input.uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}
</style>
